module.exports = "./images/stbrumpf.png";